import {
  Component,
  Output,
  EventEmitter,
  ViewEncapsulation,
  signal,
} from "@angular/core";
import { AppSettings } from "src/app/config";
import { CoreService } from "src/app/services/core.service";
import { TablerIconsModule } from "angular-tabler-icons";
import { MaterialModule } from "src/app/material.module";
import { FormsModule } from "@angular/forms";
import { NgScrollbarModule } from "ngx-scrollbar";

@Component({
  selector: "app-customizer",
  imports: [TablerIconsModule, MaterialModule, FormsModule, NgScrollbarModule],
  templateUrl: "./customizer.component.html",
  styleUrls: ["./customizer.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class CustomizerComponent {
  options: AppSettings;

  @Output() optionsChange = new EventEmitter<AppSettings>();
  hideSingleSelectionIndicator = signal(true);

  constructor(private settings: CoreService) {
    this.options = settings.getOptions();
  }

  setDark(theme: string) {
    this.options.theme = theme;

    this.saveSettings();
    this.emitOptions();
  }

  setColor(color: string) {
    this.options.activeTheme = color;
    this.saveSettings();
    this.emitOptions();
  }

  setDir(dir: "ltr" | "rtl") {
    this.options.dir = dir;
    this.saveSettings();
    this.emitOptions();
  }

  setSidebar(sidenavOpened: boolean) {
    this.options.sidenavOpened = sidenavOpened;
    this.saveSettings();
    this.emitOptions();
  }

  private saveSettings() {
    this.settings.setOptions(this.options);
  }

  private emitOptions() {
    this.optionsChange.emit(this.options);
  }
}
